import { dimmer } from "./dimmer";
import { humanDate } from "./humanDate";
import { notify } from "./notify";
import { presentGicItems } from "./presentGicItems";
import { request } from "./request";
import { cModal } from "./modal";
import { scroll } from "./scroll";
import { lang, languages, status } from "../app";
import { v4 as uuid } from "uuid";

export const buildGicEditor = (id, author, userLevel) => {
	let editValues;
	if (id) {
		let gicItem = window.gicItems.find(item => item.id === id);
		editValues = gicItem.langs[lang]
			? gicItem.langs[lang]
			: {
					createdBy: author,
					headline: "",
					lang: lang,
					link: "",
					pubTime: new Date().getTime(),
					publication: "",
					position: (window.gicItems.filter(item => item.langs[lang]).length + 1).toString()
			  };
	}
	let gicEditor = $(`<div class="uk-inline">
            <h3>Gulfstream in the Community item editor</h3>
            <button data-button="cancel gic edit" class="uk-button uk-button-danger">Cancel</button>
            <button data-button="submit gic edit" class="uk-button uk-button-primary">Submit</button>
        </div>
        <div id="gic_editor" class="uk-margin uk-margin-remove-horizontal">
            <div data-wrapper="gic_form_wrapper">
                <form data-lang="${lang}" uk-grid class="uk-grid-small" id="gic_form" enctype="multipart/form-data" autocomplete="off">
                    <div class="uk-width-1-1 uk-width-1-2@s">
                        <label for="gicDate">Date of item</label>
                        <input class="uk-input" type="date" value="${id ? editValues.pubTime : ""}" name="pubTime">
                    </div>
                    <div class="uk-width-1-1 uk-width-1-2@s">
                        <label for="gicPublication">Publication</label>
                        <input class="uk-input" type="text" value="${id ? editValues.publication : ""}" name="publication">
                    </div>
                    <div class="uk-width-1-1 uk-width-1-2@s">
                        <label for="gicHeadline">Headline</label>
                        <input class="uk-input" type="text" value="${id ? editValues.headline : ""}" name="headline">
                    </div>
                    <div class="uk-width-1-1 uk-width-1-2@s">
                        <label for="gicLink">Link</label>
                        <input class="uk-input" type="url" value="${id ? editValues.link : ""}" name="link">
                    </div>
                </form>
            </div>
        </div>`);

	$("#gic_editor_wrapper").html(gicEditor);
	// instantiate bio editor

	scroll(gicEditor, 100);

	let form = gicEditor.find("#gic_form");
	$(".flatpickr-calendar").remove();
	// get rid of any existing flatpickr calendars hanging around

	flatpickr("[name='pubTime']", {
		altInput: true,
		altFormat: "F j, Y",
		dateFormat: "U",
		defaultDate: id ? editValues.pubTime : new Date().getTime(),
		enableTime: false
	});
	// initialize calendar input

	form.find("[name]").on("input", function () {
		$(this).removeClass("error");
	});
	// remove error state if new info entered

	$("[data-button='cancel gic edit']").on("click", function (e) {
		e.preventDefault();
		$("#gic_editor_wrapper").html("").addClass("hidden");
	});
	// cancel GIC edit click handler

	$("[data-button='submit gic edit']").on("click", async function (e) {
		e.preventDefault();
		form.find(".error").removeClass("error");
		let gicVals = {};
		let valid = true;
		form.serializeArray().forEach(val => {
			gicVals[val.name] = val.name === "pubTime" ? parseInt(val.value) * 1000 : val.value;
			if (!val.value) {
				valid = false;
				form.find(`[name='${val.name}']`).addClass("error");
			}
		});
		// are entries valid?

		if (valid) {
			form.append(dimmer());
			try {
				await cModal(`<h4>Just checking...</h4>
				<p>You are about to publish a ${languages[lang]}-language "In the Community" item with the following information:</p><p>Publication: ${gicVals.publication}</p><p>Date: ${humanDate(gicVals.pubTime)}</p><p>Headline: ${gicVals.headline}</p><p>Link: ${gicVals.link}</p><p class="bold">Is this the plan?</p>`);

				gicVals.updatedBy = author;
				let data;
				if (id) {
					gicVals.position = editValues.position;
					// preserve position from original data

					data = window.gicItems.find(item => item.id === id);
					data.langs[lang] = gicVals;
					// overwrite old values with the new
				} else {
					gicVals.createdBy = author;
					// document whose login was active at
					// creation of this In the Community item

					gicVals.position = (window.gicItems.filter(item => item.langs && item.langs[lang]).length + 1).toString();

					data = {
						id: uuid(),
						langs: {
							[lang]: gicVals
						}
					};
				}
				data.type = "gic";
				// type is the primary key for this table

				let params;
				if (id) {
					// this is an edit, so we're upserting values via data service batchWrite
					params = {
						reqId: "4b9d14f5-1255-4f03-8b6a-da2363fe25ee",
						data: [
							{
								PutRequest: {
									Item: data
								}
							}
						]
					};
				} else {
					params = {
						reqId: "9e3c8e67-4671-4f56-87c3-abf8c07a7772",
						data: data
					};
				}
				notify(`Saving "In the Community" item to database ...`);
				try {
					const response = await request(params, $("#gic_form"));
					if (id) {
						Object.assign(
							window.gicItems.find(item => item.id === id),
							data
						);
					}
					// existing item in in-memory GIC items updated
					else {
						window.gicItems.push(data);
					}
					// new item added to end of in-memory gicItems array

					notify(`"In the Community" item successfully saved`, "success");
					$("#gic_editor_wrapper").html("");
					presentGicItems(author, userLevel);
				} catch (err) {
					throw err;
				}
			} catch (err) {
				form.find(".dimmer").remove();
				if (err) {
					console.error("There was an error saving this In the News item:", err);
					notify("There was an error saving this item", "danger");
				}
			}
		}
		// form passed validation
		else {
			notify("Please fill out all fields", "danger", "bottom-center");
		}
	});
	// submit GIC button click handler
};
// end buildGicEditor function
